import React from 'react';
import './AssistantLogo.css';

const AssistantLogo = ({ isThinking, isSpeaking, size = 'medium' }) => {
    return (
        <div className={`assistant-logo-wrapper ${size} ${isThinking ? 'thinking' : ''} ${isSpeaking ? 'speaking' : ''}`}>
            <svg viewBox="0 0 100 100" className="assistant-svg">
                <defs>
                    <linearGradient id="logo-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" style={{ stopColor: '#00c6ff', stopOpacity: 1 }} />
                        <stop offset="100%" style={{ stopColor: '#0072ff', stopOpacity: 1 }} />
                    </linearGradient>
                    <filter id="glow">
                        <feGaussianBlur stdDeviation="2.5" result="coloredBlur" />
                        <feMerge>
                            <feMergeNode in="coloredBlur" />
                            <feMergeNode in="SourceGraphic" />
                        </feMerge>
                    </filter>
                    <clipPath id="core-circle">
                        <circle cx="50" cy="50" r="19" />
                    </clipPath>
                </defs>

                {/* Background Ring */}
                <circle cx="50" cy="50" r="45" className="logo-ring-bg" />

                {/* Animated Inner Rings (More rings for Saara) */}
                <circle cx="50" cy="50" r="40" className="logo-ring-inner pulse-1" />
                <circle cx="50" cy="50" r="35" className="logo-ring-inner pulse-2" />
                <circle cx="50" cy="50" r="30" className="logo-ring-inner pulse-3" />
                <circle cx="50" cy="50" r="25" className="logo-ring-inner pulse-4" />

                {/* Core Image (Guru's Face with Blue Glow) */}
                <g className="logo-core-group" filter="url(#glow)">
                    <circle cx="50" cy="50" r="22" className="logo-core-bg" style={{ fill: '#3b82f6', stroke: '#fff', strokeWidth: '1.5px' }} />
                    <image
                        href="images/profilepic.jpg"
                        x="32" y="32" width="36" height="36"
                        clipPath="url(#core-circle)"
                        className="logo-avatar"
                    />
                </g>

                {/* Thinking/Speaking Waves */}
                {(isThinking || isSpeaking) && (
                    <g className="wave-group">
                        <path d="M 30 50 Q 40 30 50 50 T 70 50" className="wave wave-1" />
                        <path d="M 30 50 Q 40 70 50 50 T 70 50" className="wave wave-2" />
                    </g>
                )}
            </svg>
        </div>
    );
};

export default AssistantLogo;
